
import {
  vendordata_updateincompleteRequiredFields
} from "reducers/vendordata/vendordata";

export { formatData, checkValidity };

function formatData(part, data, appdata, vendordata, suffix = "") {
  let returnData = {};

  if (vendordata.activeVendor[part].hasOwnProperty("0")) {
    // multi part object, such as contacts and banks
    Object.keys(vendordata.activeVendor[part]).map(key => {
      returnData[key] = {
        DELETED: vendordata.activeVendor[part][key]["DELETED"] ? true : false,
        REMOVE: vendordata.activeVendor[part][key]["REMOVE"] ? true : false,
        SEQ: vendordata.activeVendor[part][key]["SEQ"],
        item: singlePart(part, data, appdata, vendordata, suffix = "", key)
      }
    })
  }
  else {
    // single parts, such as general data and purchasung data
    returnData = singlePart(part, data, appdata, vendordata, suffix)
  }

  return returnData;
}



function singlePart(part, data, appdata, vendordata, suffix = "", multipartkey = null) {
  let returnData = {};
  // this is used for international versions that
  // has a suffix for the data
  // like company.street will be company.street_C
  let useSuffix = "";
  if (suffix != "") {
    useSuffix = "_" + suffix;
  }


  Object.keys(data).map(key => {
    if (data[key]) {
      let obj = {
        label: data[key].label,
        required: data[key].required ? true : false,
        hidden: data[key].hidden ? true : false
      };

      // the part has to be selected from a list
      // such as the company
      if (
        data[key].list &&
        appdata.listvalues.hasOwnProperty(data[key].list) &&
        Object.keys(appdata.listvalues[data[key].list]).length > 0
      ) {
        let listToUseForPart = appdata.listvalues[data[key].list];
        let valueSAP = "";
        let valueActive = "";
        let valueActivePart = "";

        if (multipartkey) {
          listToUseForPart.map((item, keylist) => {
            if (
              Object.keys(vendordata.activeVendor).length > 0 && vendordata.activeVendor[part] && vendordata.activeVendor[part][multipartkey] && item[data[key].listKeys[0]] === vendordata.activeVendor[part][multipartkey][key + useSuffix]
            ) {
              valueActivePart = item[data[key].listKeys[0]];
              valueActive = item[data[key].listKeys[0]] + " - " + item[data[key].listKeys[1]];
            }
            if (
              Object.keys(vendordata.sapVendor).length > 0 && vendordata.sapVendor[part] && vendordata.sapVendor[part][[multipartkey]] && item[data[key].listKeys[0]] === vendordata.sapVendor[part][multipartkey][key + useSuffix]
            ) {
              valueSAP =
                item[data[key].listKeys[0]] + " - " + item[data[key].listKeys[1]];
            }
          });
        }
        else {
          listToUseForPart.map((item, keylist) => {
            if (
              Object.keys(vendordata.activeVendor).length > 0 && vendordata.activeVendor[part] && item[data[key].listKeys[0]] === vendordata.activeVendor[part][key + useSuffix]
            ) {
              valueActivePart = item[data[key].listKeys[0]];
              valueActive = item[data[key].listKeys[0]] + " - " + item[data[key].listKeys[1]];
            }
            if (
              Object.keys(vendordata.sapVendor).length > 0 && vendordata.sapVendor[part] && item[data[key].listKeys[0]] === vendordata.sapVendor[part][key + useSuffix]
            ) {
              valueSAP =
                item[data[key].listKeys[0]] + " - " + item[data[key].listKeys[1]];
            }
          });
        }

        obj = {
          ...obj,
          sap: valueSAP,
          active: valueActive,
          key: key,
          value: valueActivePart,
          listKeys: data[key].listKeys,
          list: appdata.listvalues[data[key].list]
        };
      } else if (!data[key].list) {
        // the part is a direct copy from the value
        // the part is a direct copy from the value
        // the part is a direct copy from the value
        let sapValue = "";
        let activeValue = "";

        if (multipartkey) {
          if (Object.keys(vendordata.sapVendor).length > 0 && vendordata.sapVendor[part] && vendordata.sapVendor[part][multipartkey]) {
            sapValue = vendordata.sapVendor[part][multipartkey][key + useSuffix];
          }

          if (Object.keys(vendordata.activeVendor).length > 0 && vendordata.activeVendor[part] && vendordata.activeVendor[part][multipartkey]) {
            activeValue = vendordata.activeVendor[part][multipartkey][key + useSuffix];
          }


          obj = {
            ...obj,
            sap: sapValue,
            active: activeValue
          };
        }
        else {
          if (Object.keys(vendordata.sapVendor).length > 0 && vendordata.sapVendor[part]) {
            sapValue = vendordata.sapVendor[part][key + useSuffix];
          }
          if (Object.keys(vendordata.activeVendor).length > 0 && vendordata.activeVendor[part]) {
            activeValue = vendordata.activeVendor[part][key + useSuffix];
          }
          obj = {
            ...obj,
            sap: sapValue,
            active: activeValue,
            maxLength: data[key].maxLength ? data[key].maxLength : null
          };
        }
      } else {
        // there is a list, but it is not populated yet, add alternative text
        // for instance 'please select company first' for the region
        obj = {
          ...obj,
          alternativeText: vendordata.vendorParts[part][key].alternativeText
            ? vendordata.vendorParts[part][key].alternativeText
            : ""
        };
      }

      returnData[key] = obj;
    }
  });

  return returnData

}



function checkValidity(vendordata, dispatch) {

  // check if all the required fields are filled
  // check if all the required fields are filled
  // check if all the required fields are filled
  // check if all the required fields are filled
  Object.keys(vendordata.vendorParts).map(part => {
    console.log("checkpart", part);
    if (part == "PURCHASING" || part == "COMPANY") {
      if (vendordata.activeVendor.hasOwnProperty(part)) {
        Object.keys(vendordata.vendorParts[part]).map(field => {
          if (vendordata.vendorParts[part][field].required) {
            let fieldComplete = true;

            if (!vendordata.activeVendor[part].hasOwnProperty(field)) {
              // field is not found on active vendor
              fieldComplete = false;
            }
            else if (vendordata.activeVendor[part][field] == "" || vendordata.activeVendor[part][field] == null) {
              // field is found on active vendor, but empty
              fieldComplete = false;
            }

            if (!fieldComplete) {
              if (!vendordata.incompleteRequiredFields.hasOwnProperty(part) || !vendordata.incompleteRequiredFields[part].hasOwnProperty(field)) {
                // field is NOT complete and NOT in uncomplete fields list, ADD it
                dispatch(vendordata_updateincompleteRequiredFields({ part: part, field: field }))
              }
            }

            if (fieldComplete) {
              if (vendordata.incompleteRequiredFields.hasOwnProperty(part) && vendordata.incompleteRequiredFields[part].hasOwnProperty(field)) {
                // field is complete and in uncomplete fields list, REMOVE it
                dispatch(vendordata_updateincompleteRequiredFields({ part: part, field: field, remove: true }))
              }

            }
          }
        })
      }
    }
    else if (part == "CONTACT" || part == "BANK") {
      //console.log("check contact or bank")
      if (vendordata.activeVendor.hasOwnProperty(part)) {
        console.log(vendordata.activeVendor[part]);
        let validParts = [];
        Object.keys(vendordata.activeVendor[part]).map(key => {
          // loop through all the contacts / banks
         /*  if (vendordata.activeVendor[part][key]["REMOVE"] == "X" || vendordata.activeVendor[part][key]["DELETED"] == "X") {
            console.log("CHECK - field is not valid, removed or deleted", part,key);
          }
          else {
            console.log("CHECK - field is valid and incomplete", part, key) */
            validParts.push(key);
          /* } */
        })

        // no single valid part is found, add the part as empty fieldset
        if (validParts.length == 0) {
          dispatch(vendordata_updateincompleteRequiredFields({ part: part }))
        }
        else {
          // valid parts found, check them to see if any data is missing
          validParts.map(key => {
            //console.log("check valid part", key)

            Object.keys(vendordata.vendorParts[part]).map(field => {
             // console.log("check field", field);
              if (vendordata.vendorParts[part][field].required) {
                let fieldComplete = true;
                if (!vendordata.activeVendor[part][key].hasOwnProperty(field)) {
                  // field is not found on active vendor
                  fieldComplete = false;
                }
                else if (vendordata.activeVendor[part][key][field] == "" || vendordata.activeVendor[part][key][field] == null) {
                  // field is found on active vendor, but empty
                  fieldComplete = false;
                }

                if (!fieldComplete && vendordata.activeVendor[part][key]["REMOVE"] != "X" && vendordata.activeVendor[part][key]["DELETED"] != "X") {
                  if (
                    !vendordata.incompleteRequiredFields.hasOwnProperty(part) ||
                    (vendordata.incompleteRequiredFields.hasOwnProperty(part) && !vendordata.incompleteRequiredFields[part].hasOwnProperty(key))
                    || (vendordata.incompleteRequiredFields[part][key].includes(field))) {
                    // field is NOT complete and NOT in uncomplete fields list, ADD it
                    dispatch(vendordata_updateincompleteRequiredFields({ part: part, field: field, id: key }))
                  }
                }

                if (fieldComplete || vendordata.activeVendor[part][key]["REMOVE"] == "X" || vendordata.activeVendor[part][key]["DELETED"] == "X") {
                 // console.log("field complete", part, key, field);
                  if (vendordata.incompleteRequiredFields.hasOwnProperty(part)) {
                    //console.log("really complete 1 ", vendordata.incompleteRequiredFields[part].hasOwnProperty(key));
                    if (vendordata.incompleteRequiredFields[part].hasOwnProperty(key)) {
                      //console.log("really complete 2 ");
                      if (vendordata.incompleteRequiredFields[part][key].includes(field)) {
                        //console.log("really complete 3 ");
                        // field is complete and in uncomplete fields list, remove it

                        dispatch(vendordata_updateincompleteRequiredFields({ part: part, field: field, id: key, remove: true }))
                      }
                    }
                  }
                }
              }
            })
          })
        }
      }
    }
  })

}